var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDnsPmIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2694_42807)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2694_42807",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 36,
    height: 36
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 0H0V36H36V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2694_42807)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.0469 0.0620117H2.80706C1.67518 0.0620117 0.769678 1.02262 0.769678 2.1662V16.3466C0.769678 16.8041 1.13188 17.17 1.53936 17.17C1.94683 17.17 2.30903 16.8041 2.30903 16.3466V2.1662C2.30903 1.89174 2.49013 1.70877 2.76178 1.70877H34.0016C34.228 1.70877 34.4544 1.93749 34.4544 2.1662V33.9578C34.4544 34.2323 34.2733 34.4153 34.0016 34.4153H2.76178C2.53541 34.4153 2.30903 34.1865 2.30903 33.9578V22.8422C2.71651 22.5677 2.98816 22.1103 2.98816 21.5614C2.98816 20.738 2.30903 20.0061 1.49408 20.0061C0.679127 20.0061 0 20.6923 0 21.5614C0 22.1103 0.271651 22.5677 0.679127 22.8422V33.9578C0.679127 35.1014 1.58463 36.062 2.71651 36.062H33.9564C35.0882 36.062 35.9938 35.1014 35.9938 33.9578V2.12046C36.0843 0.976878 35.1788 0.0620117 34.0469 0.0620117Z",
    fill: "#006098"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1567 25.4515V10.5298H17.3632C17.95 10.5298 18.467 10.6066 18.9141 10.7603C19.3612 10.914 19.7664 11.1865 20.1296 11.5777C20.4929 11.9689 20.7444 12.4299 20.8841 12.9608C21.0238 13.4778 21.0937 14.1834 21.0937 15.0776C21.0937 15.7482 21.0517 16.314 20.9679 16.7751C20.8981 17.2362 20.7374 17.6693 20.4859 18.0745C20.1925 18.5635 19.8013 18.9477 19.3123 19.2271C18.8233 19.4926 18.1806 19.6253 17.3842 19.6253H16.2944V25.4515H14.1567ZM16.2944 12.5417V17.6134H17.3213C17.7544 17.6134 18.0898 17.5505 18.3273 17.4248C18.5648 17.299 18.7394 17.1244 18.8512 16.9009C18.963 16.6913 19.0259 16.4328 19.0398 16.1254C19.0678 15.818 19.0817 15.4757 19.0817 15.0985C19.0817 14.7492 19.0748 14.4209 19.0608 14.1135C19.0468 13.7922 18.9839 13.5127 18.8722 13.2752C18.7604 13.0377 18.5927 12.8561 18.3692 12.7303C18.1456 12.6046 17.8243 12.5417 17.4051 12.5417H16.2944Z",
    fill: "#0174C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.75 25.4515V10.5298H8.91458C10.1441 10.5298 11.0732 10.8651 11.7019 11.5357C12.3446 12.2064 12.666 13.1565 12.666 14.386V21.3648C12.666 22.762 12.3237 23.7959 11.6391 24.4665C10.9684 25.1232 9.9974 25.4515 8.72596 25.4515H5.75ZM7.88767 12.5417V23.4396H8.87267C9.47345 23.4396 9.89958 23.2929 10.1511 22.9995C10.4026 22.6921 10.5283 22.2171 10.5283 21.5744V14.386C10.5283 13.7991 10.4095 13.3451 10.172 13.0237C9.93451 12.7024 9.50139 12.5417 8.87267 12.5417H7.88767Z",
    fill: "#0174C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0435 25.4423V10.5386H24.0948L26.8369 18.43H26.8788L29.6 10.5386H31.6723V25.4423H29.5372V16.3787H29.4953L27.3812 22.7839H26.3136L24.2204 16.3787H24.1785V25.4423H22.0435Z",
    fill: "#0174C3"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2694_42807"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDnsPmIcon);
export default __webpack_public_path__ + "static/media/dnsPmIcon.6c75dbb72a6820a750fa3039be2cddd3.svg";
export { ForwardRef as ReactComponent };